export default function Config(dimensions, config) {
    if (!dimensions)
        dimensions = {width: 0, height: 0}

    function sidePanelWidth(align) {
        if (config.align === align)
            return 0

        if (config.align === 'center')
            return (dimensions.width - config.width) / 2 - 5

        return dimensions.width - config.width - 10
    }


    this.leftWidth = () => {
        return sidePanelWidth('left')
    }

    this.rightWidth = () => {
        return sidePanelWidth('right')
    }

    this.topHeight = () => {
        return dimensions.height - config.height
    }

    this.doorWidth = () => {
        return Number(config.width) + 10
    }
}


